import { projects, units, paymentMethods, passwordRecoveryModal, editImage, changePasswordModal, profileForm, floorsList, catalogSettingsModal, filters, login, countries, } from 'i18n/ar.common';
export default {
    translation: {
        main: {
            statistics: {
                tooltipText: "منذ آخر تحديث",
                tooltipPreLaunchText: "سعر ما قبل الإطلاق",
                chartPreLaunchPointText: "قبل الإطلاق",
            },
            metroStation: {
                line: "خط {{lineCode}}",
                plannedStation: "محطة مخطط لها",
                builtStation: "محطة قائمة",
                subtitle: "محطة مترو",
            },
            header: {
                title: { ...projects },
                search: {
                    placeholder: "البحث باسم المشروع أو المطور",
                    noMatch: "لا يوجد تطابق",
                },
            },
            districtView: {
                description: "الوصف",
                descriptionHide: "إخفاء",
                descriptionShow: "إظهار",
                developers: "المطورون",
                places: "أماكن",
                projectsCount_one: "{{count}} مشروع",
                projectsCount_two: "{{count}} مشاريع",
                projectsCount_few: "{{count}} مشاريع",
                projectsCount_many: "{{count}} مشاريع",
                projectsCount_other: "{{count}} مشاريع",
                from: "من",
            },
            projectView: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                descriptionHide: "إخفاء",
                descriptionShow: "إظهار",
                addToCatalog: "مشروع إلى الكتالوج",
                floor: "طابق",
                resale: 'Resale',
                distress: 'Distress',
                priceWithCommission: "السعر شامل العمولة",
                priceWithoutCommission: "السعر بدون عمولة",
                unitFeature: "ميزة الوحدة",
                unitView: "إطلالة من النافذة",
                unitsOnRequestHint: {
                    start: "بعض الوحدات من مخزون المطور متاحة عند طلب ",
                    link: "المدير",
                    end: ".",
                },
                unitContactsModalTitle: "جهات اتصال",
                unitContactsModalOk: "موافق",
                unitContactsAria: "جهات اتصال بيع الوحدة",
                unitsOnRequestBlockTitle: 'وحدات عند الطلب', // I18N
                unitsOnRequestBlockTitleSome: 'بعض وحدات المطور عند الطلب', // I18N
                unitsOnRequestBlockDescription: 'اتصل بالمدير للحصول على جميع التفاصيل حول الوحدات في هذا المشروع.', // I18N
                tabs: {
                    information: {
                        title: "معلومات",
                        developer: "مطور",
                        district: "منطقة",
                        price: "السعر",
                        pricePerSquare: "السعر لكل",
                        size: "الحجم",
                        postHandover: "بعد التسليم",
                        handover: {
                            title: "الاكتمال",
                            ready: "جاهز",
                        },
                        ownershipType: {
                            title: "نوع الملكية",
                            leasehold: "حق انتفاع",
                            freehold: "ملكية حرة",
                        },
                        unitType: "نوع الوحدة",
                        serviceCharge: {
                            TH: "صندوق التمويل/رسوم الصيانة",
                            default: "رسوم الخدمة",
                        },
                        furnishing: "التأثيث",
                        startOfSales: "بدء المبيعات",
                        eoi: {
                            title: {
                                MX: "حجز",
                                default: "إبداء الاهتمام (EOI)",
                            },
                            from: "من",
                            upTo: "حتى",
                            hint: {
                                MX: "يعتمد المبلغ النهائي للحجز على الوحدة المحددة وشروط البائع.",
                                default: "يعتمد المبلغ النهائي لإبداء الاهتمام على الوحدة المحددة وشروط البائع.",
                            },
                        },
                        noc: "إعادة البيع مسموح بها بعد",
                        projectConfigurations: "تكوينات المشروع",
                        managersContacts: "جهات اتصال المطور",
                        managersName: "الاسم",
                        managersPhone: "هاتف",
                        hide: "إخفاء",
                        show: "إظهار",
                        yes: "نعم",
                        no: "لا",
                    },
                    units: {
                        title: "وحدات",
                        ...units,
                        from: "من",
                        floor: "طابق",
                        resale: 'Resale',
                        distress: 'Distress',
                        priceWithCommission: "السعر شامل العمولة",
                        priceWithoutCommission: "السعر بدون عمولة",
                        unitFeature: "ميزة الوحدة",
                        unitView: "إطلالة من النافذة",
                    },
                    amenities: {
                        title: "وسائل الراحة",
                    },
                    paymentPlans: {
                        title: "خطط الدفع",
                        postHandover: "بعد التسليم",
                        noPostHandover: "لا يوجد بعد التسليم",
                        ...paymentMethods,
                    },
                    documentsAndVideos: {
                        title: "المستندات والفيديو",
                    },
                    placesNearby: {
                        title: "أماكن قريبة",
                    },
                    seller: {
                        title: "البائع",
                        salesManagers: "مديرو المبيعات",
                        salesManagersDescription: "جهات اتصال",
                        resaleContactsHint: "للتواصل بشأن وحدة إعادة البيع، يرجى الرجوع إلى بطاقة الوحدة.",
                        comission: "عمولة",
                        comissionDescription: "رسوم العمولة المطبقة",
                        comissionItemDescription: "نسبة الصفقات",
                        address: "موقع المكتب",
                        descriptionShow: "إظهار",
                        descriptionHide: "إخفاء",
                        clipboard: "تم النسخ!",
                    },
                },
                placesNearby: {
                    meters: "أمتار",
                },
                seller: {
                    title: "البائع",
                    salesManagers: "مديرو المبيعات",
                    salesManagersDescription: "جهات اتصال",
                    resaleContactsHint: "للتواصل بشأن وحدة إعادة البيع، يرجى الرجوع إلى بطاقة الوحدة.",
                    commission: "عمولة",
                    commissionDescription: "رسوم العمولة المطبقة",
                    commissionItemDescription: "نسبة الصفقات",
                    address: "موقع المكتب",
                    descriptionShow: "إظهار",
                    descriptionHide: "إخفاء",
                    clipboard: "تم النسخ!",
                },
            },
        },
        personal: {
            companies: {
                broker: "وسيط",
                developer: "مطور",
                agency: "وكالة", // I18N
            },
        },
        settings: {
            title: "الإعدادات",
            profile: {
                title: "الملف الشخصي",
            },
            language: {
                title: "اللغة",
                ru: "الروسية",
                en: "الإنجليزية",
                ar: "العربية", // I18N,
            },
            currency: {
                title: "العملة",
            },
            measures: {
                title: "وحدات القياس",
            },
            map: {
                title: "الخريطة",
            },
            showDistricts: {
                title: "إظهار المناطق على الخريطة",
            },
        },
        profile: {
            title: "الملف الشخصي",
            changePassword: "تغيير كلمة المرور",
            logout: "تسجيل الخروج",
            cancel: "إلغاء",
            save: "حفظ",
        },
        catalog: {
            title: "كتالوج",
            clear: "مسح",
            preview: "معاينة",
            floor: "طابق",
            ...floorsList,
            empty: {
                title: "كتالوجك فارغ",
                description: "أضف مشاريع أو كائنات من الخريطة لبدء العمل مع كتالوجك",
                button: "الذهاب إلى الخريطة",
            },
        },
        preview: {
            title: "معاينة",
            generate: "إنشاء كتالوج",
        },
        login,
        resetPassword: {
            header: "استعادة كلمة المرور",
            body: "أنشئ كلمة مرور جديدة. يجب أن تتكون من 8 أحرف على الأقل وتحتوي على حرف كبير وصغير ورقم ورمز.",
            uppercaseAndLowercaseLetterTitle: "يجب أن تحتوي كلمة المرور على حرف صغير وحرف كبير واحد على الأقل.",
            oneDigitTitle: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.",
            specialSymbolTitle: "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل.",
            minimumLengthTitle: "يجب أن يكون طول كلمة المرور 8 أحرف على الأقل.",
            password: "كلمة المرور الجديدة",
            passwordConfirmation: "تأكيد كلمة المرور الجديدة",
            passwordSubmited: {
                header: "لديك الآن كلمة مرور جديدة!",
                body: "تم إنشاء كلمة المرور الجديدة بنجاح ويمكنك الآن استخدامها لتسجيل الدخول إلى Geniemap.",
            },
            createPassword: "حفظ كلمة المرور",
            ok: "موافق",
        },
        projectsList: {
            projects_one: "{{ count }} مشروع",
            projects_two: "{{ count }} مشاريع",
            projects_few: "{{ count }} مشاريع",
            projects_many: "{{ count }} مشاريع",
            projects_other: "{{ count }} مشاريع",
            noResultsFound: "لم يتم العثور على نتائج",
            tryDifferentSearchOptions: "حاول استخدام خيارات بحث مختلفة",
            project: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                priceFrom: "السعر من",
                handover: "تسليم",
            },
        },
        common: {
            passwordRecoveryModal,
            changePasswordModal,
            editImage,
            profileForm,
            catalogSettingsModal,
            filters,
            countries: countries,
        },
        ws: {
            catalog: {
                start_catalog_generate: "بدأ الكتالوج في التوليد.",
                catalog_generated: "تم إنشاء الكتالوج بنجاح",
                warning: "تحذير",
            },
            auth: {
                logout: "تم تسجيل خروجك بسبب كثرة الاتصالات من حسابك.",
            },
        },
    },
};
